import { createGlobalStyle } from 'styled-components';
import { baseStyles } from './global/base.styles';
import { antdOverrides } from './global/antd-overrides.styles';
import { utilityStyles } from './global/utilities.styles';
import { formModalStyles } from './shared/form-modal.styles';

export const GlobalStyle = createGlobalStyle`
  ${baseStyles}
  ${antdOverrides}
  ${utilityStyles}
  ${formModalStyles}
`;
